import type { ScanJob } from '@repo/api-gw-sdk';

import {
  jobId,
  jobResourceName,
  resourceId,
  resourceType,
  sourceAccount,
  sourceRegion,
} from '@/components/queryBuilder/properties';
import type { FilterProperty } from '@/types/advanceFilter';

export const scanJobItemFields = [
  jobId,
  jobResourceName,
  resourceType,
  resourceId,
] as FilterProperty<ScanJob>[];

export const sourceLocationFields = [
  sourceAccount,
  sourceRegion,
] as FilterProperty<ScanJob>[];
